import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

const qrOrderService = {
  async getPending() {
    return apiClient.get(ENDPOINTS.QR_ORDERS.GET_PENDING);
  },

  async getAll(status, businessDate) {
    const params = {};
    if (status) params.status = status;
    if (businessDate) params.businessDate = businessDate;
    return apiClient.get(ENDPOINTS.QR_ORDERS.GET_ALL, { params });
  },

  async approve(id) {
    return apiClient.put(ENDPOINTS.QR_ORDERS.APPROVE(id));
  },

  async reject(id, reason) {
    return apiClient.put(ENDPOINTS.QR_ORDERS.REJECT(id), { reason });
  },
};

export default qrOrderService;
